import { useMediaQuery } from "react-responsive";

export const usePlatforms = () => {
  const useMinMediaQuery = (width: number) => useMediaQuery({ query: `(min-width: ${width}px)` });
  const useMaxMediaQuery = (width: number) => useMediaQuery({ query: `(max-width: ${width}px)` });
  const useBetweenMediaQuery = (minWidth: number, maxWidth: number) =>
    useMediaQuery({ query: `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)` });

  return {
    useMinMediaQuery,
    useMaxMediaQuery,
    useBetweenMediaQuery,
  };
};
